import React from 'react';
import ReactDOM from 'react-dom';
import PaymentApp from './PaymentApp';
import ErrorBoundary from './ErrorBoundary';
import './App.css';

// Global error handlers for uncaught errors
window.onerror = (message, source, lineno, colno, error) => {
  console.error('[Global Error]', { message, source, lineno, colno, error });
};

window.onunhandledrejection = (event) => {
  console.error('[Unhandled Promise Rejection]', event.reason);
};

/**
 * Entry point - Payment Link Checkout
 *
 * Routes:
 *   /pay?session_id=xxx  → Checkout page
 *   /complete            → Payment result
 */
ReactDOM.render(
  <ErrorBoundary>
    <div className="App">
      <PaymentApp />
    </div>
  </ErrorBoundary>,
  document.getElementById('root')
);
